/**
 * ANQ.ContentServiceManagement.API 
 * Content Service Mgt API
 *
 * OpenAPI spec version: v1
 * Contact: support@coure-tech.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export type PortStatusEnum = 0 | 1 | 2;

export const PortStatusEnum = {
    NUMBER_0: 0 as PortStatusEnum,
    NUMBER_1: 1 as PortStatusEnum,
    NUMBER_2: 2 as PortStatusEnum
};